import "./saga";
export * from "./slice";

const getCommonState = (state) => state.common;

const getDeptResponders = (state, property) => {
  const _state = getCommonState(state);
  const depts = getDepartments(state);
  let deptResponders = _state[property];
  let responders = [];
  if (depts.length > 0) {
    responders = depts.map((_) => {
      let item = { departmentLabel: _.label, departmentId: _.id }
      let responder = deptResponders.find((resp) => (resp.department_name === _.id));
      if (responder) {
        item = { ...item, ...responder }
      }
      return item;
    })
  }
  return responders;
}

export const getDepartments = (state) => {
  const _state = getCommonState(state);
  return _state.departments
}

export const getIncidentDeptResponders = (state) => {
  return getDeptResponders(state, 'incidentDeptResponders')
}

export const getTaskDeptResponders = (state) => {
  const _state = getCommonState(state);
  return _state.taskDeptResponders 
}
export const getDeptResponderByDept = (responders, dept, state) => {
  let list = [];
  if (Array.isArray(responders)) {
    list = responders;
  } else {
    if (responders === 'incident') {
      list = getIncidentDeptResponders(state)
    } else if (responders === 'continuity') {
      list = getContinuityDeptResponders(state)
    }
    else if (responders === 'task') {
      list = getTaskDeptResponders(state)
    }
  }
  return list.find((_) => (_.departmentId === dept));
}
export const getContinuityDeptResponders = (state) => {
  const _state = getCommonState(state);
  return _state.continuityDeptResponders;
}
export const getTaskProrityTypes = (state) => {
  const _state = getCommonState(state);
  return _state.taskPriorityTypes;
}
export const getTaskStatusTypes = (state) => {
  const _state = getCommonState(state);
  return _state.taskStatusTypes;
}
export const isMiscLoaded = (state) => {
  const priorities = getTaskProrityTypes(state)
  const statusList = getTaskStatusTypes(state);
  return (
    Array.isArray(statusList) && statusList.length > 0 &&
    Array.isArray(priorities) && priorities.length > 0
  )
}